// extracted by mini-css-extract-plugin
export default {"navigation":"TNZ8B","item":"RTG9X","active":"T03B4"};